import * as api from "../firebase/firebaseApi.js";
import * as ui from "../ui/ui.js";

class Board {
  constructor(board, words) {
    this.board = board;
    this.words = words;
    this.foundWords = new Array(words.length).fill(false);
  }

  getWordFromIndices(indices) {
    return indices.map((i)=>this.board[i]).join('');
  }

  getScore(word) {
    const l = word.length;
    if (l > 3) {
      return (l - 3) * 400;
    } else if (l == 3) {
      return 100;
    }
    return 0;
  }

  get totalScore() {
    let total = 0;
    for (let i = 0; i < this.words.length; i++) {
      if (this.foundWords[i]) total += this.getScore(this.words[i]);
    }
    return total;
  }

  onPathComplete(indices) {
    const word = this.getWordFromIndices(indices);
    const index = this.words.indexOf(word);

    if (index >= 0) {
      if (this.foundWords[index] == false) {
        this.foundWords[index] = true;
        return { type: "found", score: this.totalScore, word };
      } else {
        return { type: "refound", word };
      }
    }

    if (index == -1) {
      return { type: "unlisted", word };
    }
  }
}

export class GameClient {
  constructor(userId) {
    this.userId = userId;
		this.matchId = null;
    this.player = "";
    api.createUser(userId);
    this.board = null;
  }

  #unsubscribe;

  createMatch() {
    this.matchId = this.userId;
    this.player = "player1";
    api.getRandomBoard().then(({board, words, boardId}) => {
      this.board = new Board(board, words);
      api.createMatch(this.matchId, boardId);
    }).catch((e)=>{
      console.error("Create match error:", e);
    });
  }

  startMatch() {
    ui.createGrid(this.board.board);
    ui.updateScore(0);
    // TODO: API call to create start time, append to database, go to pregame
  }

  joinMatch(matchId) {
    return api.joinMatch(this.userId, matchId).then((a) => {
      this.matchId = matchId;
      this.player = "player2";
      this.board = new Board(a.board, a.words);
      // TODO: figure out where to put this
      // ui.createGrid(a.board);
      // ui.updateScore(0);
    }).catch((e)=> {
      console.error("Join match error:", e);
    });
  }

  updateDatabasePath(path) {
    const indices = path.indices;
    return api.createRateLimitedSender((indices) => {
      const selection = ref(db(), `matches/${this.matchId}/players/${this.player}/selection`);
    }, 20);
  }

  onPathComplete(indices) {
    const event = this.board.onPathComplete(indices);
    if (event.type == "found") {
      api.foundWord(this, event.word);
    }
    return event;
  }

  updatePath(indices) {
    api.updateSelection({
      matchId: this.matchId,
      player: this.player,
      indices
    });
  }

  onReadyPlayer1(callback) {
    if (typeof callback !== "function") {
      callback = () => {};
    }

    return new Promise(async (resolve) => {
      resolve(await api.onReadyPlayer1(this.userId, this.matchId, () => {
        callback();
        // Appends to callback, the unsubscribe function returned by api.onReadyPlayer1
        // Note that at definition #unsubscribe is undefined. It is only populated
        // below, at the .then((unsubscribe) => ... statement.
        try {
          this.#unsubscribe();
        } catch (e) {
          console.error(e);
        }
      }) )
    }).then((u) => {
      this.#unsubscribe = u;
    });
  }
}

